/*
 * rd-comparison-slider.js
 *
 * Implementa <comparison-slider> (el slider de "antes y después").
 *
 * El marcado tiene el control deslizante:
 *     <input type="range" class="comparison-slider__input" min="0" max="100" value="50">
 * pero NINGÚN JS del tema lo escuchaba: ese componente vivía en el main.js
 * externo. El CSS trae "width: 50%" y "left: 50%" fijos, así que el slider se
 * pintaba a la mitad y nunca se movía.
 *
 * Detalle importante:
 * La imagen del overlay es width:100% + object-fit:cover. Si solo encogemos el
 * overlay, la imagen se re-escala (efecto zoom) en vez de revelarse. Por eso le
 * fijamos el ancho en píxeles al ancho total del slider: así el overlay actúa
 * como una ventana que recorta, que es el efecto correcto.
 */
(function () {
  'use strict';

  if (customElements.get('comparison-slider')) return;

  customElements.define(
    'comparison-slider',
    class extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('.comparison-slider__input');
        this.overlay = this.querySelector('.comparison-slider__overlay');
        this.line = this.querySelector('.comparison-slider__line');

        if (!this.input || !this.overlay) return;

        this.onInput = this.onInput.bind(this);
        this.resize = this.resize.bind(this);

        // 'input' cubre arrastre con mouse, dedo y teclado.
        this.input.addEventListener('input', this.onInput);

        this.resize();
        this.update(this.input.value);

        if (typeof ResizeObserver !== 'undefined') {
          this.observer = new ResizeObserver(this.resize);
          this.observer.observe(this);
        } else {
          window.addEventListener('resize', this.resize);
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        else window.removeEventListener('resize', this.resize);
      }

      // La imagen del overlay debe medir SIEMPRE lo mismo que el slider
      // completo, aunque el overlay se encoja. Si no, se deforma.
      resize() {
        var image = this.overlay.querySelector('img, svg');
        if (!image) return;
        image.style.width = this.clientWidth + 'px';
        image.style.maxWidth = 'none';
        this.update(this.input.value);
      }

      onInput(event) {
        this.update(event.target.value);
      }

      update(value) {
        this.overlay.style.width = value + '%';
        if (this.line) this.line.style.left = value + '%';
      }
    }
  );
})();
